import makeRequest from 'api/'

export const getCalendar = async () => {
  return await makeRequest({
    method: 'get',
    url: `/weekly-plan/calendar`,
  })
}
